import { themeOverride } from '@/theme/theme'

import { category as BudgetCategory } from '@/__generated__/requests'

export function getSpentCategoryColor(category: BudgetCategory): string {
  switch (category) {
    case BudgetCategory.FOOD:
      return themeOverride?.other?.colors.red
    case BudgetCategory.ENTERTAINMENT:
      return themeOverride?.other?.colors.orange
    case BudgetCategory.TRANSPORTATION:
      return themeOverride?.other?.colors.violet
    case BudgetCategory.MEDICAL:
      return themeOverride?.other?.colors.darkGrey
    case BudgetCategory.HOUSING:
      return themeOverride?.other?.colors.brightGreen
    case BudgetCategory.FINANCIAL:
      return themeOverride?.other?.colors.blue
    case BudgetCategory.GIVING:
      return themeOverride?.other?.colors.purple
    case BudgetCategory.OTHER:
      return themeOverride?.other?.colors.darkGreen
    default:
      return themeOverride?.other?.colors.grey
  }
}
